import { QuestionsCollection, InteractiveQuestion } from '../models/survey';
import {
    OrderResponse,
    getQuestionsCollectionFromOrderResponse,
    getInteractiveQuestionsFromOrderResponse,
} from '../api/transformations/survey';

export enum SurveyActionType {
    initSurveys = 'initSurveys',
}

export interface InitSurveysAction {
    type: SurveyActionType.initSurveys;
    payload: {
        questionsCollection: QuestionsCollection;
        interactiveQuestions: Array<InteractiveQuestion>;
    };
}
export const getInitSurveysAction = (payload: {
    questionsCollection: QuestionsCollection;
    interactiveQuestions: Array<InteractiveQuestion>;
}): InitSurveysAction => ({
    type: SurveyActionType.initSurveys,
    payload,
});

export const getInitSurveysActionFromOrderResponse = (
    orderResponse: OrderResponse,
): InitSurveysAction =>
    getInitSurveysAction({
        questionsCollection:
            getQuestionsCollectionFromOrderResponse(orderResponse) ?? {},
        interactiveQuestions:
            getInteractiveQuestionsFromOrderResponse(orderResponse) ?? [],
    });

export type SurveyAction = InitSurveysAction;
